import React from 'react';

import CheckoutCreateAccount from './CreateAccount';
import CheckoutSuccess from './Success';
import CheckoutPaymentInformation from './PaymentInformation';
import CheckoutAddAddress from './AddAddressStep';
import CheckoutDeliveryDetails from './DeliveryDetails';

import './style.less';

export default class Checkout extends React.Component {
  render() {
    return (
      <div className="checkout">
        {this.props.children}
      </div>
    );
  }
}

export {
  CheckoutCreateAccount,
  CheckoutSuccess,
  CheckoutPaymentInformation,
  CheckoutAddAddress,
  CheckoutDeliveryDetails
};



/** WEBPACK FOOTER **
 ** ./src/views/checkout/index.js
 **/